angular.module('dnecom')
    .controller('ProductsSettingsController', ["$scope", "$http", "notifications", function ProductsSettingsController($scope, $http, notifications) {
        $scope.store = TemplateData.value('store');
        $scope.properties = TemplateData.value('store-properties');
        $scope.defaultProperties = {
            description: 'below_the_title',
            social_button: 'at_the_bottom',
            timer_progress_bar: 'below_images',
            badges: 'below_the_button'
        };

        $scope.store.properties = {};
        if ($scope.properties.hasOwnProperty('productPageLayout')) {
            $scope.store.properties.productPageLayout = angular.copy($scope.properties.productPageLayout);
        } else {
            $scope.store.properties.productPageLayout = angular.copy($scope.defaultProperties);
        }

        var validateForm = function (form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();

                return false;
            }

            return true;
        };

        $scope.save = function (form) {
            if (!validateForm(form)) {
                return false;
            }

            $http.put(
                Routing.generate('stores_update_settings', { id: $scope.store.id, group: 'ProductPageLayout' }),
                $scope.store
                )
                .then(function (response) {
                    if (response.data.success) {
                        notifications.success('Product page layout settings were successfully saved.');
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function () {
                    notifications.danger('Request error.');
                });

            return true;
        };

        $scope.settingsIsNotDefault = function () {
            return !angular.equals($scope.store.properties.productPageLayout, $scope.defaultProperties);
        };

        $scope.reset = function () {
            $scope.store.properties.productPageLayout = angular.copy($scope.defaultProperties);
        };
    }]);